module.exports = __webpack_public_path__ + "static/media/22ESCWA20.4b624182.jpg";